import { Component, Input, Output, EventEmitter } from "@angular/core";
import { ComparativeAnalysisService } from "src/app/comparative-analysis/comparative-analysis.service";
import { Subscription } from "rxjs";
import { CustomSkeletonConfig } from "src/app/shared/custom-skeleton/custom-skeleton-model";

@Component({
  selector: "app-watchlist-search-menu",
  templateUrl: "./watchlist-search-menu.component.html",
  styleUrls: ["./watchlist-search-menu.component.scss"],
})
export class WatchlistSearchMenuComponent {
  @Input() data;
  @Input() searchedValue = "";
  @Input() isLoading: boolean = false;
  @Input() isMcapGeoDataLoading: boolean = false;
  @Input() marketCapData;
  @Input() geographyData;
  @Input() otherGeoLen;
  @Input() selectionInMegaMenu;
  @Input() isCreateNewModalIndustryMenu: boolean = false;
  @Output() onMarketCapSelect: EventEmitter<any> = new EventEmitter();
  @Output() onCancelButtonClick: EventEmitter<any> = new EventEmitter();
  @Output() onApplyButtonClick: EventEmitter<any> = new EventEmitter();
  prevId: string = "";

  skeletonDefaultConfig: CustomSkeletonConfig = {
    skeletonType: "list",
    config: {
      list: {
        noOfListItems: 8,
      },
    },
  };

  totalTickerCount = 0;

  @Input() selectedMarketCaps: Array<number> = [-1];
  @Input() selectedCountires: Array<number> = [];
  @Input() selectedRegions: Array<number> = [-1];
  @Input() watchlistId;
  watchlistName;
  isWatchlistSelected;

  companyCountSubscriber: Subscription;

  constructor(private comparativeAnalysisService: ComparativeAnalysisService) {}

  ngOnChanges(changes) {
    if (
      (changes.watchlistId &&
        changes.watchlistId.currentValue &&
        changes.watchlistId.currentValue !==
          changes.watchlistId.previousValue) ||
      (changes.data && changes.data.currentValue !== changes.data.previousValue)
    ) {
      if (this.data) {
        this.data.forEach((element) => {
          const isSelected = element.id === this.watchlistId;
          element.selected = isSelected;
          if (isSelected) {
            this.watchlistName = element.label;
            this.isWatchlistSelected = true;
            this.fetchTickerCount();
          }
        });
      }
    }
  }

  handleMarketCapChange(data) {
    this.selectedMarketCaps = data;
    this.fetchTickerCount();
  }

  handleGeographyChange(data) {
    if (
      !data.isAllGeographySelected &&
      data.countries.length === 0 &&
      data.regions.length === 0
    ) {
      this.totalTickerCount = 0;
      this.selectedRegions = data.region;
    } else {
      if (data.countries) {
        this.selectedCountires = data.countries;
      }
      if (data.regions) {
        this.selectedRegions =
          data.regions.length === data.otherGeographyLen ? [-1] : data.regions;
      }
      this.fetchTickerCount();
    }
  }

  handleCancelButtonClick() {
    this.onCancelButtonClick.emit();
  }

  handleApplyButtonClick() {
    if (this.totalTickerCount) {
      const result = {
        market_cap: this.selectedMarketCaps,
        country_id: this.selectedCountires
          ? this.selectedCountires.map((item) => {
              if (item[0] === "C") {
                return (item as any).slice(1) * 1;
              }
              return item * 1;
            })
          : undefined,
        region_id: this.selectedRegions
          ? this.selectedRegions.length === this.otherGeoLen
            ? [-1]
            : this.selectedRegions.map((item) => {
                if (item[0] === "R") {
                  return item[1] * 1;
                }
                return item * 1; //This is to make sure that only array of number is passed as region_id
              })
          : undefined,
        watchlist_id: this.watchlistId,
        watchlistName: this.watchlistName,
      };
      this.onApplyButtonClick.emit(result);
    }
  }

  handleListClick(item) {
    // if (this.prevId !== item.id) {
    //   this.data.forEach((watchlist) => {
    //     if (watchlist.id === this.prevId) {
    //       watchlist.selected = false;
    //       this.isWatchlistSelected = false
    //     }
    //   });
    // }
    // item["selected"] = item["selected"] ? false : true;
    // this.prevId = item.id;
    // if (item.id) {
    //   this.watchlistId = item.id;
    //   this.fetchTickerCount();
    // }

    this.data.forEach((watchlist) => {
      if (watchlist.id === item.id) {
        watchlist.selected = true;
      } else {
        watchlist.selected = false;
      }
    });
    if (item.id && item.id !== this.prevId) {
      this.watchlistId = item.id;
      this.watchlistName = item.label;
      this.isWatchlistSelected = true;
      this.fetchTickerCount();
    }
    this.prevId = item.id;
  }

  fetchTickerCount() {
    const payload = {
      market_cap: this.selectedMarketCaps,
      country_id: this.selectedCountires
        ? this.selectedCountires.map((item) => {
            if (item[0] === "C") {
              return (item as any).slice(1) * 1;
            }
            return item * 1;
          })
        : undefined,
      region_id: this.selectedRegions
        ? this.selectedRegions.length === this.otherGeoLen
          ? [-1]
          : this.selectedRegions &&
            this.selectedRegions.map((item) => {
              if (item[0] === "R") {
                return item[1] * 1;
              }
              return item * 1; //This is to make sure that only array of number is passed as region_id
            })
        : undefined,
      watchlist_id: this.watchlistId,
      type: "watchlist",
    };
    if (this.watchlistId) {
      this.companyCountSubscriber = this.comparativeAnalysisService
        .fetchCompaniesCount(payload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.totalTickerCount = response.count;
          }
        });
    } else {
      this.totalTickerCount = 0;
    }
  }
}
